<template>
  <div>
    <div v-if="$nav.show" class="x-nav">
      <div class="x-nav-fixed a-ipx-top-border" :style="'background-color: ' + bgColor">
        <div v-if="showNavBack" class="x-nav-back" @click="onClickBack">
          <div
            class="x-nav-back-arrow"
            :style="'border-left: 2px solid '+fontColor+'; border-bottom: 2px solid '+fontColor+';'"
          ></div>
        </div>
        <div
          class="x-nav-title"
          :style="'color: ' + fontColor + ';background-color: ' + bgColor || '#ffffff'"
        >{{ $nav.title }}</div>
        <div
          v-if="navRightBtn"
          class="x-nav-btn"
          :style="'color: ' + fontColor"
          @click="navRightBtn.fn"
        >{{navRightBtn.name}}</div>
      </div>
      <div class="placeholder a-ipx-border-border" :style="'background-color: ' + bgColor"></div>
    </div>
  </div>
</template>

<script>

/**
 * url里加参数firstNoBack=1，则入口页的nav不展示回退按钮
 */
export default {
  name: "c-nav",
  props: ["bgColor", "fontColor", "navRightBtn"],
  computed: {
    showNavBack() {
      if (this.$nav.firstPageShowBack) {
        return this.$nav.showBack;
      } else {
        let historyLen = window.gtHistoryPageLen;
        return !historyLen || historyLen === 1 ? false : this.$nav.showBack;
      }
    }
  },
  methods: {
    onClickBack() {
      if (this.$route.query.paid) {
        this.$router.go(-2);
      } else {
        this.$router.back();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

.x-nav-fixed {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  background-color: #fff;
  height: $x-nav-height;
  max-width: 750px;
  margin: 0 auto;
}
.x-nav-back {
  position: absolute;
  padding: 14px 20px;
}
.x-nav-back-arrow {
  width: 10px;
  height: 10px;
  border-left: 2px solid #000;
  border-bottom: 2px solid #000;
  transform: rotate(45deg);
}
.x-nav-title {
  padding: 10px 30px;
  font-size: 17px;
  /* height: 20px; */
  line-height: $x-nav-height / 2;
  color: #000;
  background-color: #fff;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.x-nav-btn {
  position: absolute;
  font-size: 17px;
  right: 0;
  top: 0;
  padding: 10px;
}
.placeholder {
  width: 100%;
  height: $x-nav-height;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/c-nav.vue